import breakpoints from 'client/utils/constants/GDS/js/breakpoints';
import { MOBILE, TABLET, DESKTOP } from 'client/utils/constants/GDS/js/devices';

const userAgent = () => navigator?.userAgent;

const detectMobileBrowser = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator?.userAgent);
};

export const isMobile = (width) => {
    return width <= breakpoints.mobile;
};

export const isTablet = (width) => {
    return width > breakpoints.mobile && width <= breakpoints.desktop;
};

export const isDesktop = (width) => {
    return width > breakpoints.tablet;
};

export const detect = (width) => {
    if (width < breakpoints.tablet) {
        return MOBILE;
    } else if (width < breakpoints.desktop) {
        return TABLET;
    }
    return DESKTOP;
};

export default { userAgent, detectMobileBrowser, isMobile, isTablet, isDesktop, detect };
